import { defineStore } from "pinia";
import { ref } from "vue";
import svc from "@/services/hrm/adminAttendance.service";
import { toast } from "@/utils/toast";
import { createScopedCache } from "./_cache";

const attendanceStatsCache = createScopedCache("dashboard:admin:attendance:hero");
const ATTENDANCE_STATS_TTL = 60 * 1000;

export const useAdminAttendanceStatsStore = defineStore(
  "adminAttendanceStats",
  () => {
    const loading = ref(false);
    const error = ref(null);
    const stats = ref({
      date: null,
      total_employees: 0,
      present: 0,
      absent: 0,
      present_pct: 0,
      absent_pct: 0,
    });

    async function fetchStats(params = {}) {
      loading.value = true;
      error.value = null;
      try {
        const payload = await attendanceStatsCache.get(params, {
          ttlMs: ATTENDANCE_STATS_TTL,
          force: params.force === true,
          loader: async () => {
            const { data } = await svc.stats(params);
            return {
              date: data.date ?? null,
              total_employees: Number(data.total_employees ?? 0),
              present: Number(data.present ?? 0),
              absent: Number(data.absent ?? 0),
              present_pct: Number(data.present_pct ?? 0),
              absent_pct: Number(data.absent_pct ?? 0),
            };
          },
          onHydrate: (data) => {
            stats.value = data;
          },
        });
        stats.value = payload;
      } catch (e) {
        error.value =
          e?.response?.data?.message || "Failed to load attendance stats";
        toast(error.value, "error");
      } finally {
        loading.value = false;
      }
    }

    async function ensureStats(params = {}) {
      return await fetchStats({ ...params, force: false });
    }

    function invalidateStats(params = null) {
      if (params) attendanceStatsCache.invalidate(params);
      else attendanceStatsCache.clear();
    }

    return {
      stats,
      loading,
      error,
      fetchStats,
      ensureStats,
      invalidateStats,
    };
  }
);
